<template>
    <div class="section full-height" id="pageTop" :class="pagename" v-lazy:background-image="imgUrl">
        <div class="inner-contents">
            <div v-if="pagename !== 'open_lecture'" class="logo-wrap">
                <LogoYobo class="logo" />
                <TextYobo class="word" />
                <div class="rounded">
                    <span>{{ title }}</span>
                </div>
            </div>
            <div v-else class="content-wrap">
              <span class="bubble">
                  免疫を高める秘訣が<br>簡単にわかる
                  <img src="@/assets/bubble.svg">
              </span>
              <p class="title">動画で見る<br>「市民公開講座」</p>
              <p class="subtitle">- 免疫を味方にして<br class="displayS">新型コロナウイルスに負けない -</p>
              <p class="subtitle">第41回「健康づくり提唱のつどい」</p>
              <p class="supported">supported by 株式会社ヤクルト本社</p>
            </div>
            <div v-scroll-to="{ el: '#of_the_year', offset: 200 }" v-if="pagename === 'recipe'" class="anchor">
              <div class="anchor_body">
                <div class="anchor_sub">決定！</div>
                <div class="anchor_main">
                  <p>「予防めし」</p>
                  <p>オブ・ザ・イヤー</p>
                </div>
              </div>
              <div class="anchor_link">受賞レシピ<br class="hidePc">を見る</div>
            </div>
        </div>
    </div>
</template>

<script>
import LogoYobo from '@/assets/logo-yobo.svg?inline'
import TextYobo from '@/assets/txt-yobo.svg?inline'

import bg1 from '@/assets/page/bg-recipe.jpg'
import bg1Sp from '@/assets/page/bg-recipe_sp.jpg'
import bg2 from '@/assets/page/bg-movie.jpg'
import bg2Sp from '@/assets/page/bg-movie_sp.jpg'
import bg3 from '@/assets/page/bg-open_lecture.jpg'
import bg3Sp from '@/assets/page/bg-open_lecture_sp.jpg'

import { vueWindowSize } from 'vue-window-size';
 
vueWindowSize.init();

export default {
    name: 'page-top-section',
    props:{
        pagename: String,
        title: String
    },
    components:{
        LogoYobo,
        TextYobo
    },
    data(){
        return{
            imgUrl: String,
            Screen: Number
        }
    },
    created(){
        window.addEventListener('resize', this.resized)
    },
    methods:{
        resized(e){
            vueWindowSize.init();
            if(this.windowWidth < 769){
                this.bgChange()
            }
            if(this.windowWidth > 769){
                this.bgChange()
            }
        },
        bgChange(){
            if(this.pagename == 'movie'){
                if( this.windowWidth < 769 ){
                    this.imgUrl = bg2Sp
                }
                else{
                    this.imgUrl = bg2
                }
            }
            if(this.pagename == 'recipe'){
                if( this.windowWidth < 769 ){
                    this.imgUrl = bg1Sp
                }
                else{
                    this.imgUrl = bg1
                }
            }
            if(this.pagename == 'about'){
                this.imgUrl = ''
            }
            if(this.pagename == 'open_lecture'){
                if( this.windowWidth < 769 ){
                    this.imgUrl = bg3Sp
                }
                else{
                    this.imgUrl = bg3
                }
            }
        }
    },
    mounted(){
        this.bgChange()
    }
    
}
</script>

<style lang="scss" scoped>
#pageTop{
    width: 100vw;
    height: 100vh;
    background-size: cover;
    background-position: center;
    background-color: #f7f7f7;
    filter:  blur(10px);
    transition: 0.6s;
    position: relative;
    &[lazy=loaded] {
        filter: none;
        transition: 0.6s;
        .inner-contents{
            opacity: 1;
            transition: 0.4s;
            transition-delay: 0.6s;
        }
    }
    .inner-contents{
        opacity: 0;
        transition: 0.4s;
    }
    &.recipe{
        .logo-wrap{
            svg{
                fill: $white;
            }
            .rounded{
                color: $black;
                background: $white;
            }
        }
        .anchor {
          width: 236px;
          height: 236px;
          background: $yellow;
          color: white;
          border-radius: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          text-align: center;
          transition: 0.3s;
          position: absolute;
          bottom: 83px;
          right: 30px;
          cursor: pointer;
          @media #{$maxM}{
            width: 100%;
            max-width: 335px;
            height: 93px;
            left: 50%;
            bottom: 60px;
            transform: translate(-50%, 0);
            flex-direction: row;
            box-sizing: border-box;
            padding-right: 25px;
          }
          @media screen and (max-width:360px) { 
            width: 90%;
            bottom: 40px;
          }
          &_body {
            margin-top: -10px;
            @media #{$maxM}{
              margin-top: 0px;
            }
          }
          &_sub {
            width: 102px;
            height: 25px;
            font-size: 20px;
            background-image: url('~@/assets/icon-spreading-line.svg');
            background-size: contain;
            background-repeat: no-repeat;
            margin: 0 auto;
            padding-left: 10px;
            line-height: 1;
            @media #{$maxM}{
              width: 79px;
              height: 19px;
              font-size: 16px;
            }
          }
          &_main {
            font-size: 16px;
            margin: 10px 0 14px;
            line-height: 1.8;
            letter-spacing: 0.05em;
            width: 193px;
            height: 63px;
            background-image: url('~@/assets/leaf_w.svg');
            background-size: contain;
            background-repeat: no-repeat;
            p:last-child {
              margin-top: 3px;
            }
            @media #{$maxM}{
              font-size: 14px;
              width: 165px;
              height: 46px;
              margin: 2px 0 0;
              background-image: url('~@/assets/leaf_w_sp.svg');
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              p {
                line-height: 1;
              }
              p:last-child {
                margin-top: 5px;
              }
            }
          }
          &_link {
            font-size: 12px;
            color: black;
            position: relative;
            @media #{$maxM}{
              font-size: 12px;
              line-height: 1.6;
              margin-left: 5px;
            }
            &:after {
              content: '';
              width: 18px;
              height: 18px;
              display: inline-block;
              background-image: url('~@/assets/icon-arrow_b.svg');
              background-size: contain;
              background-repeat: no-repeat;
              position: absolute;
              bottom: -25px;
              left: 50%;
              transform: translate(-50%, 0);
              @media #{$maxM}{
                width: 24px;
                height: 24px;
                top: 50%;
                bottom: auto;
                left: auto;
                right: -38px;
                transform: translate(-50%, -50%);
              }
            }
          }
          @media #{$minM}{
            &:hover {
              opacity: 0.8;
            }
          }
        }
    }
    &.about{
        background-color: transparent;
        filter: none;
        .inner-contents{
            opacity: 1;
        }
        .logo-wrap{
            svg{
                fill: $black;
            }
            .rounded{
                color: $black;
                background: #DEDEDE;
            }
        }
    }
    &.movie{
        background-position: center;
        @media #{$maxM}{
            //background-image: url('~@/assets/page/bg-movie_sp.jpg');
        }
        .logo-wrap{
            svg{
                fill: $white;
            }
            .rounded{
                color: $white;
                background: $black;
                min-width: 340px;
                @media #{$maxM}{
                    min-width: 270px;
                }
            }
        }
    }
    .logo-wrap{
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        width: calc(25vw + 10px);
        min-width: 240px;
        margin-bottom: 44px;
        @media #{$maxM}{
            margin-bottom: 30px;
        }
        @media #{$IE}{
          svg{
            width: 355px;
          }
          svg:first-child {
            height: 326.5px;
          }
          svg:nth-child(2) {
            height: 27.44px;
          }
          @media #{$maxM}{
            svg{
              width: 240px;
            }
            svg:first-child {
              height: 200px;
            }
            svg:nth-child(2) {
              height: 18.02px;
            }
          }
        }
        .logo{
            width: 100%;
            height: 23.66vw;
            min-height: 200px;
            margin-bottom: 26px;
                #circle{
                    animation-name: rotateLogo;
                    animation-timing-function: linear;
                    animation-iteration-count: infinite;
                    animation-duration: 18s;
                    transform-origin: center;
                }
            @media #{$maxM}{
                margin-bottom: 18px;
            }
        }
        .word{
            width: calc(100% - 20px);
            padding: 0 10px;
            height: auto;
        }
        .rounded{
            width: auto;
            min-width: 100%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            padding: 22px 0;
            border-radius: 5px;
            margin-top: 44px;
            opacity: 0.8;
            box-sizing: border-box;
            white-space: pre;
            @media #{$maxM}{
                margin-top: 30px;
                padding: 16px;
            }
                span{
                    font-size: 1.563em;
                    letter-spacing: 0.2em;
                    @media #{$maxM}{
                        font-size: 1.429em;
                    }
                }
            @media #{$IE}{
              padding: 25px 0 10px;
            }
        }
    }
    .content-wrap {
      text-align: center;
      .bubble {
        display: block;
        font-size: 1.5625em;
        line-height: 1.5;
        letter-spacing: 0.25em;
        width: 374px;
        height: 172px;
        margin: 0 auto 15px;
        padding-top: 40px;
        box-sizing: border-box;
        position: relative;
        img {
            position: absolute;
            top: 0;
            left: 0;
        }
        @media #{$maxM}{
          font-size: 1.285715em;
          width: 285px;
          height: 131px;
          background-size: 285px 131px;
          padding-top: 33px;
          margin: 0 auto 8px;
        }
      }
      .title {
        font-size: 3em;
        letter-spacing: 0.2em;
        @media #{$maxM}{
          font-size: 2.7em;
        }
      }
      .subtitle {
        font-size: 1.5625em;
        letter-spacing: 0.2em;
        margin-top: 5px;
        @media #{$maxM}{
          font-size: 1.285715em;
        }
      }
      .supported {
        font-size: 1.125em;
        text-align: center;
        background: black;
        color: white;
        border-radius: 20px;
        display: inline-block;
        padding: 0.2em 1.8em;
        margin-top: 37px;
        @media #{$maxM}{
          font-size: 1em;
          margin-top: 20px;
        }
      }
    }
}

@keyframes rotateLogo {
    0%{
        transform: rotate(0deg) scale(0.95);
    }
    50%{
        transform: rotate(180deg) scale(1); 
    }
    100%{
       transform: rotate(360deg) scale(0.95); 
    }
}
</style>